import { defineComponent as _defineComponent } from 'vue'
import type { CollectionType } from '@/enums/collection-type';
import type { FilterCollection, FilterName } from '@/stores/filter.store';

import ResetButton from '@/components/buttons/ResetButton.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';

import { isFilterActive } from '@/helpers/filter-helper';
import { TitleObjectType } from '@/interfaces/titles';

import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { useConstantStore, useFilterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterAgeCertification',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};



const { ageCertifications } = useConstantStore();

const { t } = useI18n();
const title = computed(() => {
	let title = t('WEBAPP_AGERATING');

	if (ageCertifications.value.organizations.length > 0) {
		title += ` (${ageCertifications.value.organizations.join(',')})`;
	}

	return title;
});

const isMovieFilterSelected = computed(() => props.currentFilters.content_types.includes(TitleObjectType.MOVIE));
const isShowFilterSelected = computed(() => props.currentFilters.content_types.includes(TitleObjectType.SHOW));

function isFilterCurrentlyActive(filterName: FilterName, value: any) {
	return isFilterActive(filterName, value, props.currentFilters);
}

const { toggle } = useFilterStore();
function ageCertificationClicked(certificateName: string) {
	const selectedState: 1 | 0 = isFilterCurrentlyActive('age_certifications', certificateName) ? 0 : 1;
	toggle({ filterName: 'age_certifications', value: certificateName, selectedState });
}

return { __sfc: true,props, ageCertifications, t, title, isMovieFilterSelected, isShowFilterSelected, isFilterCurrentlyActive, toggle, ageCertificationClicked, ResetButton, ToggleButton }
}

})